var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-background",style:({ 'background-image': 'url(' + _vm.image + ')' }),attrs:{"id":"iiotLoginBackgroundImage"}},[_c('img',{attrs:{"id":"iiotLoginLogo","src":_vm.logo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }